<template>
  <div>
    <div class="page-header">
      <v-layout row align-center>
        <v-icon x-large>mdi-login</v-icon>
        <h1 class="page-title">Tournament Signup</h1>
      </v-layout>
    </div>
    <h2></h2>
    <v-card>
      <v-card-title>{{ tourny.title }}</v-card-title>
      <v-card-subtitle>{{ tourny.description }}</v-card-subtitle>
      <v-card-subtitle>To pay enter your name, after a name is entered the PayPay button will appear.  Click the PayPal button and follow their directions.
        You can optionally enter any notes, like who your partner will be for a two man tournament.</v-card-subtitle>
      <v-card-text>
        <v-row>
          <v-col cols="12" sm="2" md="2" lg="1" xl="1"><v-text-field readonly v-model="payment.amount" label="Amount"></v-text-field></v-col> 
          <v-col cols="12" sm="10" md="10" lg="3" xl="3"><v-text-field label="Name" @change="onChangeName" v-model="payment.name"></v-text-field></v-col> 
          <v-col cols="12" sm="12" md="12" lg="8" xl="8"><v-text-field label="Notes" v-model="payment.notes"></v-text-field></v-col> 
        </v-row> 
          
      </v-card-text>
      <v-card-actions>
        <!-- Client ID: AUOkd56xOtY-AQV1kys0yvbJS-A0f2ltnyJQJ6r4Hwbj4rcxiB4aMD_XmxQs5dXM_ZFRYnIi3NYTkxMe -->
        <!-- EB8zecDCjonC-SW2d8uWsFUTUHoFBgOTEcVSyBHtmt63gV9373td85mCs6RoGpf7t0JycOQRO4myV63t -->

        <PayPal v-if="valid"
          :amount="tourny.amount"
          currency="USD"
          :client="paypal"
          env="production"
          @payment-completed="onPaymentCompleted"
        >
        </PayPal>
      </v-card-actions>
    </v-card>
    <statusalert ref="alert" returnUrl="/schedule"></statusalert>
  </div>
</template>

<script>
import apiService from "@/services/api/api-service.js"
import DateService from '../../services/manager/DateService.js'
import EventsService from '../../services/api/EventsService.js'
import router from '@/router/index.js'
import statusalert from '../../components/StatusAlert'
import store from '@/store/index.js'
import PayPal from 'vue-paypal-checkout';

export default {
  components: {
    PayPal,
    statusalert,
  },
  name: 'tournament-pay',
  store: store,
  data() {
    return {
      paypal: {
        sandbox: 'AUOkd56xOtY-AQV1kys0yvbJS-A0f2ltnyJQJ6r4Hwbj4rcxiB4aMD_XmxQs5dXM_ZFRYnIi3NYTkxMe',
        production: 'ASZukH4FpdviLLEFYPdnbsMgkKKFsIJaqVkYMB3K9PNGcqyZE0D-VmQRti6Gm8G6doYqEEKiVW3FE_Jk',
        env: 'production'
      },
      tourny: {
        amount: '0',
      },
      token: '',
      valid: false,
      payment: {
        eventId: 0,
        amount: 0,
        name: '',
        notes: '',
        receipt: '',
      }
    }
  },

  methods: {
    convertDate(dateString, full) {
      return DateService.convertDate(dateString, full)
    },

    onChangeName() {
      this.valid = this.payment.name.length > 1
      console.log(this.valid)
    },

    onPaymentCompleted(event){
      console.log(event)
      const msg = "Payment for the " + this.tourny.title + " on " + this.convertDate(this.tourny.eventStart, false) + " was received."
      const result = {
        isValid: true,
        statusCode: 200,
        errors: [msg]
      }
      this.$refs.alert.displayResult(result)
      this.payment.eventId = this.tourny.eventId;
      this.payment.receipt = JSON.stringify(event)
      const url = "payment"
      apiService.post(url, this.payment, this.paymentSuccess, this.paymentError)
    },

    paymentSuccess(result){
      console.log("Payment successful", result)
      router.push('/')
    },

    paymentError(error){
      console.log(error)
    },
  },

  mounted() {
    EventsService.getEvent(this.$route.params.eventId)
      .then((data) => {
        this.tourny = data
        this.tourny.amount = this.tourny.entryFee.toString();
        this.payment.amount = this.tourny.entryFee
      })
      .catch((error) => console.log(error))
      .finally(() => {
        store.commit('notLoading')
      })
  },

}
</script>